import React from 'react'
import { mount } from 'enzyme'
import TaxFormInput from '../../common/TaxFormInput'

// All validation testing should defer to tests for ValidationUtil.js
describe('<TaxFormInput />', () => {
  it('should render without crashing', () => {
    mount(
      <TaxFormInput onChange={() => {}} />
    )
  })
  it('should render a label if it is supplied', () => {
    const labelText = 'this is a label'
    const wrapper = mount(<TaxFormInput onChange={() => {}} label={labelText} />)
    expect(wrapper.find('label').text()).toEqual(labelText)
  })
  it('should know when it is and isn\'t focused', () => {
    const wrapper = mount(<TaxFormInput onChange={() => {}} />)
    const input = wrapper.find('input')
    const instance = wrapper.instance()
    expect(instance.state.isFocused).toBe(false)
    input.simulate('focus')
    expect(instance.state.isFocused).toBe(true)
    input.simulate('blur')
    expect(instance.state.isFocused).toBe(false)
  })
})